<template>
  <div
    class="promises"
    :class="`${blockClass}__promises-container`"
  >
    <h2
      class="promises__heading"
      :class="`${blockClass}__promises-heading text-body-m-medium`"
      v-text="promises.title"
    />
    <ul
      v-if="promises.enabled"
      class="promises__grid"
      :class="`${blockClass}__promises-grid`"
    >
      <li
        v-for="(block, index) of promises.blocks"
        :key="block.title + index"
        role="listitem"
      >
        <button
          :aria-label="block.title"
          type="button"
          :aria-current="selectedIndex === index ? 'true' : 'false'"
          :class="itemClass(index)"
          @click="selectBlock(index)"
          @keydown.enter="selectBlock(index)"
        >
          <span :class="`${blockClass}__promises-image-wrapper`">
            <responsive-image
              :image="block.image"
              class="promises__image"
              :class="`${blockClass}__promises-image`"
              min-max="48-96"
              :padding="false"
              ratio="1:1"
            />
          </span>
          <span
            v-if="block.title"
            class="promises__title"
            :class="`${blockClass}__promises-title text-body-s-medium`"
          >
            {{ block.title }}
          </span>
          <span
            class="promises__description"
            :class="`${blockClass}__promises-description is-mobile`"
            v-html="block.text"
          />
        </button>
      </li>
    </ul>
    <div
      v-if="currentDesktopDescription"
      class="promises__description"
      :class="`${blockClass}__promises-description is-desktop`"
      v-html="currentDesktopDescription"
    />
  </div>
</template>

<script>
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'PromiseGrid',
  components: {
    ResponsiveImage,
  },
  props: {
    promises: {
      type: Object,
      default: () => ({
        enabled: false,
        title: '',
        blocks: [],

      }),
    },
    blockClass: {
      type: String,
      default: '',
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: 0,
    }
  },

  computed: {

    /**
     * Returns the current promise block item description for desktop.
     * Falls back to mobile description.
     * @return {String}
     */
    currentDesktopDescription() {
      const block = this.promises.blocks[this.selectedIndex]
      return block ? block.desktopText || block.text : ''
    },
  },

  methods: {

    /**
     * Returns the classes for the promise block item.
     * @return {Array}
     */
    itemClass(index) {
      return [
        `${this.blockClass}__promises-block`,
        { [this.$class('active')]: this.selectedIndex === index },
        'promises__block',
      ]
    },

    /**
     * Selects the promise block item.
     * @param {Number} index - The index of the promise block item.
     */
    selectBlock(index) {
      this.selectedIndex = index
    },
  },
}
</script>
